import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';

type Props = {
  name: String,
  value: String,
  onChange: Function,
  className: String,
};

const StyledColorInput = styled.input(({ value }) => ({
  outline: 0,
  border: `4px solid ${value || '#333'}`,
  padding: '0',
  boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)',
  overflow: 'auto',
  cursor: 'pointer',
  borderRadius: '0',
  height: '6rem',
  width: '6rem',
  '&::-webkit-color-swatch-wrapper': { padding: 0 },
  '&::-webkit-color-swatch': { border: 'none' },
}));

const StyledColorInputWrapper = styled.div(({ value }) => ({
  ...(value ? { boxShadow: `0 .125rem .25rem ${value}` } : {}),
  border: `1px solid ${value || colors.darkGray}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  height: '100%',
  position: 'relative',
  borderRadius: '0.4rem',
  overflow: 'auto',
}));

function ColorInput({
  name,
  label,
  value = '',
  onChange,
  className = '',
  wrapperClassName = '',
}: Props) {
  return (
    <StyledColorInputWrapper className={wrapperClassName} value={value}>
      {label && <label className="p-2">{label}</label>}
      <StyledColorInput
        type="color"
        name="name"
        onChange={(c) => onChange(c.target.value)}
        value={value}
        className={className}
      />
    </StyledColorInputWrapper>
  );
}

export { ColorInput };
